import React from "react";
import { Button, Dropdown, Space } from "antd";
import { FaFileExcel, FaFilePdf } from "react-icons/fa";
import { HiOutlineChevronDown } from "react-icons/hi";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const getExportable = (columns, rows) => {
  const exportCols = columns.filter(
    (col) => col.accessor && col.isVisible !== false
  );
  const headers = exportCols.map((col) =>
    typeof col.Header === "string" ? col.Header : col.accessor
  );
  const body = rows.map((row) =>
    exportCols.map((col) => row.values[col.accessor] ?? "")
  );
  return { headers, body };
};

export const ExportButtons = ({ columns, rows, filename = "export" }) => {
  const exportToExcel = () => {
    const { headers, body } = getExportable(columns, rows);
    const ws = XLSX.utils.aoa_to_sheet([headers, ...body]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${filename}.xlsx`);
  };

  const exportToPDF = () => {
    const { headers, body } = getExportable(columns, rows);
    const doc = new jsPDF();
    autoTable(doc, { head: [headers], body });
    doc.save(`${filename}.pdf`);
  };

  const items = [
    {
      key: "excel",
      label: (
        <Space onClick={exportToExcel}>
          <FaFileExcel style={{ color: "#217346" }} />
          Excel
        </Space>
      ),
    },
    {
      key: "pdf",
      label: (
        <Space onClick={exportToPDF}>
          <FaFilePdf style={{ color: "#e53935" }} />
          PDF
        </Space>
      ),
    },
  ];

  return (
    <Dropdown menu={{ items }}>
      <Button>
        <Space>
          Export <HiOutlineChevronDown />
        </Space>
      </Button>
    </Dropdown>
  );
};
